module.exports = __webpack_public_path__ + "img/exampleLengthImage.77f39ab8.png";